// Auto-generated by scripts/split_ui.js from data/umrahMandiri.js — do not edit.
export const UM_UI = {
  "pageTitle": {
    "id": "Umrah Mandiri",
    "en": "Independent Umrah",
    "ar": "العمرة المستقلة",
    "fr": "Omra Indépendante",
    "de": "Eigenständige Umrah",
    "es": "Umrah Independiente",
    "ru": "Самостоятельная Умра",
    "zh": "独立副朝",
    "ja": "独立ウムラ",
    "ko": "독립 우므라",
    "hi": "स्वतंत्र उमरा"
  },
  "pageSub": {
    "id": "Tips & trik umrah mandiri (tanpa paket travel) beserta persiapan yang sempurna, langkah demi langkah.",
    "en": "Tips & tricks for performing Umrah independently (without a travel package), along with thorough preparation, step by step.",
    "ar": "نصائح وحيل لأداء العمرة المستقلة (بدون باقة سفر)، مع التحضير الشامل خطوة بخطوة.",
    "fr": "Conseils et astuces pour effectuer l'Omra de manière indépendante (sans forfait voyage), avec une préparation complète, étape par étape.",
    "de": "Tipps & Tricks zur eigenständigen Durchführung der Umrah (ohne Reisepaket), mit gründlicher Vorbereitung, Schritt für Schritt.",
    "es": "Consejos y trucos para realizar la Umrah de forma independiente (sin paquete de viaje), con una preparación completa, paso a paso.",
    "ru": "Советы и рекомендации по самостоятельному совершению Умры (без туристического пакета), с тщательной подготовкой, шаг за шагом.",
    "zh": "独立副朝（无旅行套餐）的技巧与建议，以及完整的逐步准备指南。",
    "ja": "旅行パッケージなしで独立してウムラを行うためのヒントとコツ、および完全な準備をステップごとに解説します。",
    "ko": "여행 패키지 없이 독립적으로 우므라를 수행하기 위한 팁과 요령, 그리고 단계별 철저한 준비 안내.",
    "hi": "बिना ट्रैवल पैकेज के स्वतंत्र रूप से उमरा करने के टिप्स और ट्रिक्स, साथ ही संपूर्ण तैयारी, कदम दर कदम।"
  },
  "dashLabel": {
    "id": "Umrah Mandiri",
    "en": "Independent Umrah",
    "ar": "العمرة المستقلة",
    "fr": "Omra Indépendante",
    "de": "Eigenständige Umrah",
    "es": "Umrah Independiente",
    "ru": "Самостоятельная Умра",
    "zh": "独立副朝",
    "ja": "独立ウムラ",
    "ko": "독립 우므라",
    "hi": "स्वतंत्र उमरा"
  },
  "dashHint": {
    "id": "Tips lengkap & checklist persiapan umrah tanpa travel",
    "en": "Complete tips & preparation checklist for Umrah without a travel agent",
    "ar": "نصائح شاملة وقائمة تحضير للعمرة بدون وكالة سفر",
    "fr": "Conseils complets et liste de contrôle de préparation pour l'Omra sans agence de voyage",
    "de": "Vollständige Tipps & Vorbereitungs-Checkliste für die Umrah ohne Reisebüro",
    "es": "Consejos completos y lista de verificación de preparación para la Umrah sin agencia de viajes",
    "ru": "Полные советы и контрольный список подготовки к Умре без туристического агентства",
    "zh": "无需旅行社的副朝完整建议与准备清单",
    "ja": "旅行代理店なしでウムラを行うための完全なヒントと準備チェックリスト",
    "ko": "여행사 없이 우므라를 위한 완전한 팁 및 준비 체크리스트",
    "hi": "बिना ट्रैवल एजेंट के उमरा के लिए संपूर्ण टिप्स और तैयारी चेकलिस्ट"
  },
  "checklistTitle": {
    "id": "Checklist Persiapan",
    "en": "Preparation Checklist",
    "ar": "قائمة التحضير",
    "fr": "Liste de Contrôle de Préparation",
    "de": "Vorbereitungs-Checkliste",
    "es": "Lista de Verificación de Preparación",
    "ru": "Контрольный список подготовки",
    "zh": "准备清单",
    "ja": "準備チェックリスト",
    "ko": "준비 체크리스트",
    "hi": "तैयारी चेकलिस्ट"
  },
  "checklistHint": {
    "id": "Centang tiap item yang sudah Anda siapkan.",
    "en": "Check off each item that you have already prepared.",
    "ar": "ضع علامة على كل بند قمت بتحضيره بالفعل.",
    "fr": "Cochez chaque élément que vous avez déjà préparé.",
    "de": "Haken Sie jeden Punkt ab, den Sie bereits vorbereitet haben.",
    "es": "Marque cada elemento que ya haya preparado.",
    "ru": "Отметьте каждый пункт, который вы уже подготовили.",
    "zh": "勾选每一项您已经准备好的内容。",
    "ja": "すでに準備した各項目にチェックを入れてください。",
    "ko": "이미 준비한 각 항목을 체크하세요.",
    "hi": "प्रत्येक आइटम को चेक करें जिसे आपने पहले से तैयार कर लिया है।"
  },
  "guideTitle": {
    "id": "Panduan & Tips Lengkap",
    "en": "Complete Guide & Tips",
    "ar": "الدليل الشامل والنصائح الكاملة",
    "fr": "Guide Complet & Conseils",
    "de": "Vollständiger Leitfaden & Tipps",
    "es": "Guía Completa y Consejos",
    "ru": "Полное руководство и советы",
    "zh": "完整指南与技巧",
    "ja": "完全ガイド＆ヒント",
    "ko": "완전한 가이드 및 팁",
    "hi": "संपूर्ण मार्गदर्शिका और सुझाव"
  },
  "progressDone": {
    "id": "siap",
    "en": "done",
    "ar": "مكتمل",
    "fr": "terminé",
    "de": "erledigt",
    "es": "listo",
    "ru": "готово",
    "zh": "已完成",
    "ja": "完了",
    "ko": "완료",
    "hi": "पूर्ण"
  },
  "reset": {
    "id": "Atur Ulang",
    "en": "Reset",
    "ar": "إعادة ضبط",
    "fr": "Réinitialiser",
    "de": "Zurücksetzen",
    "es": "Restablecer",
    "ru": "Сбросить",
    "zh": "重置",
    "ja": "リセット",
    "ko": "초기화",
    "hi": "पुनः सेट करें"
  },
  "allDone": {
    "id": "Masya Allah! Persiapan Anda sudah lengkap.",
    "en": "Masha Allah! Your preparation is complete.",
    "ar": "ما شاء الله! لقد اكتملت استعداداتك.",
    "fr": "Masha Allah ! Vos préparatifs sont complets.",
    "de": "Masha Allah! Ihre Vorbereitung ist abgeschlossen.",
    "es": "Masha Allah! Su preparación está completa.",
    "ru": "Маша Аллах! Ваша подготовка завершена.",
    "zh": "马沙安拉！您的准备工作已全部完成。",
    "ja": "マーシャーアッラー！準備が整いました。",
    "ko": "마샤 알라! 준비가 완료되었습니다.",
    "hi": "माशा अल्लाह! आपकी तैयारी पूरी हो गई है।"
  }
};
